// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bc350001","455":"d445ad8c"}[chunkId] + ".chunk.js";
};